export function isMiniProgram () {
  return window.__wxjs_environment === 'miniprogram'
}
